module.exports = __webpack_public_path__ + "img/betterIncomeSecond.75413dd0.svg";